module.exports = __webpack_public_path__ + "media/images/icons/close-white-e215122e07accdfd6060101a98d85a16.svg";